import { WIX_BLOG } from '@wix/app-definition-ids';
import { SearchDocumentType } from '@wix/client-search-sdk';
import { IndexableApp, LayoutType } from '../types';

export const BlogApp: IndexableApp = {
  documentType: SearchDocumentType.Blogs,
  appDefId: WIX_BLOG,
  translations: {
    tabLabel: 'searchResults.tabs.label.blogs',
    tabLabelWithCount: 'searchResults.tabs.label.blogs.withCount',
    tabAccessibilityLabel:
      'searchResults.tabs.label.search-category.accessibilityLabel',
  },
  layout: LayoutType.List,
};
